module.exports = __webpack_public_path__ + "5432aff48df6eb0eb88fd1db52a58144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nidilrr-logo.png
// module id = 1058
// module chunks = 0